import { render, staticRenderFns } from "./dataMove.vue?vue&type=template&id=fc6e9a96&scoped=true"
import script from "./dataMove.vue?vue&type=script&lang=js"
export * from "./dataMove.vue?vue&type=script&lang=js"
import style0 from "./dataMove.vue?vue&type=style&index=0&id=fc6e9a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6e9a96",
  null
  
)

export default component.exports